export default "__VITE_ASSET__riGZ46jJ__"